export enum AttributionType {
  NO_ATTRIBUTION = 0,
  CONTROL_LOOP = 234755,
  CONTROL_QUESTION = 234868
}
